import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { getCompanyAPI, getDistributorOptionsAPI, getPartnerTypesAPI, getPartnersAPI, savePartnersAPI, updatePartnersAPI } from "./endpoints";

function* getPartnersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getPartnersAPI, action.payload);
    yield put(actions.setPartners(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getDistributorOptionsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getDistributorOptionsAPI, action.payload);
    yield put(actions.setDistributorOptions(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getCompanySaga(action) {
  try {
    const _api = yield call(getCompanyAPI, action.payload);
    yield put(actions.setCompany(_api.data.results));
  } catch (error) {
    console.log(error);
  }
}

function* getPartnerTypesSaga(action) {
  try {
    const _api = yield call(getPartnerTypesAPI, action.payload);
    yield put(actions.setPartnerTypes(_api.data.results));
  } catch (error) {
    console.log(error);
  }
}

function* savePartnersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(savePartnersAPI, action.payload?.payload);
    if (_api?.data?.success) {
      yield put(actions.getPartners(action.payload.filter));
      yield put(
        commonActions.setAlert({
          message: "Partner Saved Successfully",
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Save Partner Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* updatePartnersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(updatePartnersAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.getPartners(action.payload.filter));
      yield put(
        commonActions.setAlert({
          message: "Partner Updated Successfully",
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Update Partner Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

export function* withPartnersSaga() {
  yield all([
    takeEvery(actionTypes.GET_PARTNERS, getPartnersSaga),
    takeEvery(actionTypes.GET_COMPANY, getCompanySaga),
    takeEvery(actionTypes.GET_PARTNER_TYPES, getPartnerTypesSaga),
    takeEvery(actionTypes.SAVE_PARTNERS, savePartnersSaga),
    takeEvery(actionTypes.UPDATE_PARTNERS, updatePartnersSaga),
    takeEvery(actionTypes.GET_DISTRIBUTOR_OPTIONS, getDistributorOptionsSaga),
  ]);
}
